import React, {useEffect, useState} from 'react';
import Wrapper from '../../components/Wrapper';
import DashboardHeader from '../../components/DashboardHeader';
import Input from '../../components/Input';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from '../../hooks/useTranslation';
import {
  useInviteFboMutation,
  useLazyGetInvitedAgencyIndexQuery,
} from '../../store/builder/inspections.api';
import {setLoader} from '../../store/builder/reducer';
import {useDispatch, useSelector} from 'react-redux';
import './index.scss';
import {Helmet} from 'react-helmet';

import CustomPaginate from '../../components/PaginateComponent';
import {useDebounce} from '../LogSheets/hooks';
import InvitedAgencyRow from '../../components/InvitedAgencyRow';
import {validationEmail} from '../../global/validate';
import {toast} from 'react-toastify';
import useLoader from '../../global/UseLoadingHandler';

export default function InvitedFbo() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const dispatch = useDispatch();
  const [list, setList] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearchValue = useDebounce(search, 500);
  const [inviteModal, setInviteModal] = useState(false);
  const [email, setEmail] = useState('');

  const [
    getInvitedAgency,
    {
      data: agencyData,
      isLoading: agencyIsLoading,
      isError: agencyIsError,
      error: agencyError,
      isSuccess: agencyIsSuccess,
    },
  ] = useLazyGetInvitedAgencyIndexQuery();

  const [
    invite,
    {
      isLoading: inviteIsLoading,
      isError: inviteIsError,
      error: inviteError,
      isSuccess: inviteIsSuccess,
    },
  ] = useInviteFboMutation();

  useLoader([agencyIsLoading, inviteIsLoading]);

  useEffect(() => {
    getInvitedAgency({search: debouncedSearchValue, page: '1'});
  }, [debouncedSearchValue]);

  useEffect(() => {
    if (agencyData) {
      setList(agencyData?.data?.map(item => ({...item, action_status: false})));
    }
  }, [agencyData]);

  useEffect(() => {
    if (!userInfo?.is_global) {
      navigate('/inspections');
    }
  }, [userInfo]);

  useEffect(() => {
    if (inviteIsSuccess) {
      getInvitedAgency({page: '1'});
      toast.success(t('invitedFbo.messages.inviteSuccess'));
      setInviteModal(false);
    }
    if (inviteIsError) {
      toast.error(inviteError?.data?.email[0]);
    }
  }, [inviteIsSuccess, inviteIsError]);

  const handleEmail = e => {
    setEmail(e.target.value);
  };

  const handleSubmitInvite = () => {
    if (validationEmail(email)) {
      invite({email: email, role_id: 2});
    } else {
      toast.error(t('invitedFbo.messages.enterCorrectEmail'));
    }
  };

  const handlePageClick = async page => {
    setCurrentPage(page.selected + 1);
    await getInvitedAgency({page: ++page.selected}).catch(err => {
      toast.error(err.response.data.message);
    });
    window.scrollTo(0, 0);
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{t('invitedFbo.pageTitle')}</title>
      </Helmet>

      <DashboardHeader
        title={t('invitedFbo.title')}
        showBtn={true}
        type='agancy-invited'
        action={() => setInviteModal(true)}
      />
      {inviteModal && (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('invitedFbo.modals.inviteFbo.title')}</p>
              <img
                className='modal__content-exit'
                src='/assets/icons/close.svg'
                alt='close'
                onClick={() => setInviteModal(false)}
              />
            </div>
            <div className={`modal__content-body`}>
              <Input
                containerWidth={'100%'}
                id='enail'
                name='emal'
                placeholder={t('invitedFbo.modals.inviteFbo.emailPlaceholder')}
                label={t('invitedFbo.modals.inviteFbo.email')}
                type={'email'}
                onChange={handleEmail}
                defaultValue=''
              />
            </div>
            <div className='modal__content-bottom'>
              <button className='close' onClick={() => setInviteModal(false)}>
                {t('actions.cancel')}
              </button>
              <button className='save' onClick={handleSubmitInvite}>
                {t('invitedFbo.modals.inviteFbo.sendLink')}
              </button>
            </div>
          </div>
          <div className='modal__bg'></div>
        </div>
      )}
      <div className='inspections agency'>
        <div className='inspections__filters'>
          <Input
            type='text'
            placeholder={t('invitedFbo.searchPlaceholder')}
            name='reportsSearch'
            id='reportsSearch'
            image={'/assets/icons/search.svg'}
            maxwidth={204}
            onChange={e => {
              setSearch(e.target.value);
            }}
          />
        </div>
        <div className='inspectionsForm__box'>
          <div className='inspectionsForm__table'>
            <div className='inspectionsForm__table-head invited'>
              <div style={{width: '50%'}} className='inspectionsForm__table-th'>
                {t('invitedFbo.tableHeaders.email')}
              </div>
              <div
                style={{width: '50%', textAlign: 'right'}}
                className='inspectionsForm__table-th'
              >
                {t('invitedFbo.tableHeaders.action')}
              </div>
            </div>

            {list?.length ? (
              list?.map(item => (
                <InvitedAgencyRow
                  item={item}
                  key={item?.id}
                  getInvitedAgency={getInvitedAgency}
                />
              ))
            ) : (
              <div className='emptyList'>
                <img src='/assets/empty-list.png' alt='empty' />
                <p>{t('invitedFbo.messages.noData')}</p>
              </div>
            )}
          </div>
          {list?.length ? (
            <CustomPaginate
              pageCount={agencyData?.pages}
              handlePageClick={handlePageClick}
            />
          ) : null}
        </div>
      </div>
    </Wrapper>
  );
}
